import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Flyout } from 'gestalt';

const styles = {
  tooltipText: {
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    color: 'white',
    fontWeight: 'bold',
  },
};

export class GestaltTooltipWrapper extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      tooltipIsOpen: !!props.message,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.message !== this.props.message) {
      this.setState({ tooltipIsOpen: !!nextProps.message });
    }
  }

  render() {
    const { message } = this.props;

    if (!this.state.tooltipIsOpen) {
      return null;
    }

    return (
      <Flyout
        anchor={this.props.anchor}
        color="darkGray"
        idealDirection="right"
        onDismiss={() => this.setState({ tooltipIsOpen: true })}
        shouldFocus={false}
        size="md"
      >
        <Box column={12} padding={3}>
          {this.props.children ? (
            <span style={styles.text}>{this.props.children}</span>
          ) : (
            <span
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: message }}
              style={styles.tooltipText}
            />
          )}
        </Box>
      </Flyout>
    );
  }
}

GestaltTooltipWrapper.propTypes = {
  anchor: PropTypes.shape(),
  message: PropTypes.string,
  children: PropTypes.element,
};

export default GestaltTooltipWrapper;
